module.exports = __webpack_public_path__ + "img/what_tip1.5321c352.png";